import { Typography } from "@mui/material"
import { red } from "@mui/material/colors"


const DisplayError = (props) =>{

    if(!props.children) return <div></div>
    return(
        <Typography variant='body2' align="center" 
        style={{
            marginBottom:20, 
            padding:'8px 8px', 
            background:red[100], 
            color:red[900], 
            fontWeight:500,
            borderRadius:8,
            border:`2px dashed ${red[500]}`
        }}>{props.children}</Typography>
    )
}

export default DisplayError